module.exports = __webpack_public_path__ + "static/media/seguros-mundial-plus.c9dcad82.svg";